module.exports = __webpack_public_path__ + "static/media/background-game-blue.3afb8866.jpg";